import { render, staticRenderFns } from "./FooterMobile.vue?vue&type=template&id=b785f724"
import script from "./FooterMobile.vue?vue&type=script&lang=js"
export * from "./FooterMobile.vue?vue&type=script&lang=js"
import style0 from "./FooterMobile.vue?vue&type=style&index=0&id=b785f724&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports